import React, { useRef, useEffect, useState } from 'react'
import { motion, useIsPresent } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Navbar from '../components/Navbar'
import SubKv from '../components/SubKv'
import SubHeader from '../components/SubHeader'
import Outro from '../components/Outro'
import Banner from '../components/Banner';
import { bannerLobby, bannerLounge } from "../assets/data/bannerData"
import { privateroomKvData, privateRoomData } from "../assets/data/subData";

gsap.registerPlugin(ScrollTrigger);


export function Privateroom() {

  const isPresent = useIsPresent();

  const title = useRef()
  const desc = useRef()
  const containerWrap = useRef()
  const imgItem = useRef([]);
  const gallery = useRef()
  const gridItem = useRef([])
  const gridWideItem = useRef([])

  const [width, setWidth] = useState(0);
  const [isFirefox, setIsFirefox] = useState(false);

  let value, tl;

  const observer = useRef(
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
          } else {
            entry.target.classList.remove('on');
          }
        });
      }, { threshold: 0.01 }
    )
  );

  // 갤러리 타임라인 생성 (반응형에 따라 kill 후 재생성)
  function createGalleryTL() {

    if (!gridItem.current[0]) return

    if (width < 768) {
      // 파이어폭스 사전 작업
      if (isFirefox) gridItem.current[2].style.transform = 'translate(-10vw, 30vw)';

      tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: gallery.current,
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            scroller: containerWrap.current,
          }
        });

      value = {
        start: {
          centerWidth: '90vw',
          centerHeight: '70vw',
          centerX: () => isFirefox ? '-10vw' : '0',
          centerY: '30vw',

          transform: '25vw',
        },
        end: {
          centerWidth: '70vw',
          centerHeight: '32.5vw',
          centerX: '0',
          centerY: '0vw',
        }
      }
    }
    else if (width < 1024) {
      // 파이어폭스 사전 작업
      if (isFirefox) gridItem.current[2].style.transform = 'translate(-12vw, 30vw)';

      tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: gallery.current,
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            scroller: containerWrap.current,
          }
        });

      value = {
        start: {
          centerWidth: '85vw',
          centerHeight: '70.3125vw',
          centerX: () => isFirefox ? '-12vw' : '0',
          centerY: '30vw',
          scale: 1,

          transform: '15vw',
        },
        end: {
          centerWidth: '60.2865vw',
          centerHeight: '27.7344vw',
          centerX: '0',
          centerY: '0',
        }
      }
    }
    else {
      // 파이어폭스 사전 작업
      if (isFirefox) gridItem.current[2].style.transform = 'translate(-10vw, 30vw)';

      tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: gallery.current,
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            scroller: containerWrap.current,
          }
        });

      value = {
        start: {
          centerWidth: '57.5521vw',
          centerHeight: '31.6667vw',
          centerX: () => { isFirefox ? '-10vw' : '0' },
          centerY: '30vw',
          scale: 1,

          transform: '12vw',
        },
        end: {
          centerWidth: '33.3333vw',
          centerHeight: '15.3646vw',
          centerX: '0',
          centerY: '0',
        }
      }
    }

    tl
      .set(gridItem.current[2], { width: value.start.centerWidth, height: value.start.centerHeight, y: value.start.centerY, x: value.start.centerX })
      .set(gridItem.current[0], { x: `-${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[5], { x: value.start.transform, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[1], { x: `-${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[6], { x: value.start.transform, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[3], { y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[4], { y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[7], { x: '-50px', y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[8], { y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridItem.current[9], { x: '50px', y: value.start.transform, scale: 0.75, opacity: 0 })

    tl
      .to(gridItem.current[2],
        {
          duration: 3,
          width: value.end.centerWidth,
          height: value.end.centerHeight,
          x: value.end.centerX,
          y: value.end.centerY,
        })
      .to(gridItem.current[0],
        {
          delay: -2.5, duration: 2.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[5],
        {
          delay: -2.5, duration: 2.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })

      .to(gridItem.current[1],
        {
          delay: -1.5, duration: 1.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[6],
        {
          delay: -1.5, duration: 1.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[3],
        {
          delay: -1.5, duration: 1.5,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[4],
        {
          delay: -1.5, duration: 1.5,
          y: '0', scale: 1, opacity: 1
        })

      .to(gridItem.current[7],
        {
          delay: -1, duration: 1,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[8],
        {
          delay: -1, duration: 1,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridItem.current[9],
        {
          delay: -1, duration: 1,
          x: '0', y: '0', scale: 1, opacity: 1
        })

  }

  // 갤러리 타임라인 생성 (반응형에 따라 kill 후 재생성)
  function createWideGalleryTL() {

    if (!gridWideItem.current[0]) return

    tl = gsap.timeline(
      {
        scrollTrigger: {
          trigger: gallery.current,
          start: "top top",
          end: "bottom bottom",
          scrub: true,
          scroller: containerWrap.current,
        }
      });

    value = {
      start: {
        centerWidth: '65vw',
        centerHeight: '31.6667vw',
        centerY: '40vw',
        scale: 1,

        transform: '18vw',
      },
      end: {
        centerWidth: '33.4271vw',
        centerHeight: '13vw',
        centerY: '-0vw',
        scaleY: 1,
      }
    }


    tl
      .set(gridWideItem.current[3], { width: value.start.centerWidth, height: value.start.centerHeight, y: value.start.centerY, scale: value.start.scale })
      .set(gridWideItem.current[2], { x: `-${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[4], { x: `${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[0], { x: `-${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[8], { x: `${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[1], { x: `-${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[9], { x: `${value.start.transform}`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[5], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[6], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[7], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[10], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[11], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[12], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })
      .set(gridWideItem.current[13], { x: `0`, y: value.start.transform, scale: 0.75, opacity: 0 })


    tl
      .to(gridWideItem.current[3],
        {
          duration: 3,
          width: value.end.centerWidth,
          height: value.end.centerHeight,
          y: value.end.centerY,
        })
      .to(gridWideItem.current[2],
        {
          delay: -2.5, duration: 2.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[4],
        {
          delay: -2.5, duration: 2.5,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[0],
        {
          delay: -2, duration: 2,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[8],
        {
          delay: -2, duration: 2,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[1],
        {
          delay: -2, duration: 2,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[9],
        {
          delay: -2, duration: 2,
          x: '0', y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[5],
        {
          delay: -1.5, duration: 1.5,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[6],
        {
          delay: -1.5, duration: 1.5,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[7],
        {
          delay: -1.5, duration: 1.5,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[10],
        {
          delay: -1, duration: 1,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[11],
        {
          delay: -1, duration: 1,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[12],
        {
          delay: -1, duration: 1,
          y: '0', scale: 1, opacity: 1
        })
      .to(gridWideItem.current[13],
        {
          delay: -1, duration: 1,
          y: '0', scale: 1, opacity: 1
        })
  }

  // 스크롤 트리거 설정 
  function setScrolltriger () {

    tl?.kill();

    if (width > 1920) {
      createWideGalleryTL();
    } else {
      createGalleryTL();
    }

    setTimeout(() => {
      tl.scrollTrigger?.refresh()
    }, 500);
  }

  // 스크롤 트리거 해제
  function offScrolltriger () {
    tl?.kill();
    tl?.scrollTrigger?.kill();
  }


  // 뷰포트 width 값 측정
  function updateWindowDimensions() {
    const newWidth = window.innerWidth;
    setWidth(newWidth);
  };



  // 마운트 시
  useEffect(() => {

    const agent = window.navigator.userAgent.toLowerCase();

    if (agent.indexOf('firefox') > -1) {
      setIsFirefox(true);
    }

    setScrolltriger()

    // 상단 섹션 이미지 애니메이션 부여
    observer.current.observe(title.current);
    observer.current.observe(desc.current);

    for (let i = 0; i < imgItem.current.length; i++) {
      observer.current.observe(imgItem.current[i]);
    }

    // 리사이즈 이벤트
    window.addEventListener("resize", updateWindowDimensions);
    window.dispatchEvent(new Event('resize', {bubbles: true}));
    
    return () => {
      observer.current.disconnect() // 옵저버 연결 끊기
      window.removeEventListener("resize", updateWindowDimensions)
      offScrolltriger();
    }
  }, []);


  // 뷰포트 width가 업데이트될 때
  useEffect(() => {

      setScrolltriger()

    return () => {
      offScrolltriger();
    }
  }, [width, isFirefox]);




  return (
    <div className="container">
      <div className="container_wrap" ref={containerWrap}>
        <Navbar />
        <SubHeader title={privateroomKvData.title} class={privateroomKvData.class} content={containerWrap.current} />
        <SubKv
          title={privateroomKvData.title}
          img={privateroomKvData.img}
          class={privateroomKvData.class} />

        <section id="PRIVATEROOM" className="contents privateroom">

          <div className="privateroom__inner">
            <div className="title__wrap">
              <span className="title" ref={title}>
                <picture>
                  <source media="(min-width: 1024px)" srcSet={privateRoomData.titleImg.pcSrc} />
                  <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.titleImg.tabSrc} />
                  <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.titleImg.moSrc} />
                  <img src={privateRoomData.titleImg.pcSrc} alt="" />
                </picture>
              </span>
              <p className="desc" ref={desc}>
                어둠 속에서도 찬란하게 빛날 희망의 징조를 상징하는<br />
                <strong>대전분사무소만의 프라이빗한 공간을 만나보세요.</strong></p>
            </div>

            <div className="contents__wrap">
              <div className="img__list l1">
                <li className="img__item" ref={el => imgItem.current[0] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img1.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img1.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img1.moSrc} />
                    <img src={privateRoomData.inner[0].img1.pcSrc} alt="" />
                  </picture>
                </li>

                <li className="img__item" ref={el => imgItem.current[1] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img2.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img2.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img2.moSrc} />
                    <img src={privateRoomData.inner[0].img2.pcSrc} alt="" />
                  </picture>
                </li>
              </div>

              <div className="img__list l2">
                <li className="img__item" ref={el => imgItem.current[2] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img3.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img3.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img3.moSrc} />
                    <img src={privateRoomData.inner[0].img3.pcSrc} alt="" />
                  </picture>
                </li>
              </div>

              <div className="img__list l3">
                <li className="img__item" ref={el => imgItem.current[3] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img4.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img4.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img4.moSrc} />
                    <img src={privateRoomData.inner[0].img4.pcSrc} alt="" />
                  </picture>
                </li>
                <p className="desc">
                  <strong>일식과 서광의 빛을 담은
                    PRIVATE ROOM</strong>은<br />
                  고객님의 더 행복할 내일로
                  안내합니다.
                </p>

                <span className="calli">
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].calli.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].calli.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].calli.moSrc} />
                    <img src={privateRoomData.inner[0].calli.pcSrc} alt="" />
                  </picture>
                </span>
              </div>


              <div className="img__list l4">
                <li className="img__item" ref={el => imgItem.current[4] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img5.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img5.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img5.moSrc} />
                    <img src={privateRoomData.inner[0].img5.pcSrc} alt="" />
                  </picture>
                </li>
                <li className="img__item" ref={el => imgItem.current[5] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img6.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img6.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img6.moSrc} />
                    <img src={privateRoomData.inner[0].img5.pcSrc} alt="" />
                  </picture>
                </li>
                <li className="img__item" ref={el => imgItem.current[6] = el}>
                  <picture>
                    <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[0].img7.pcSrc} />
                    <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[0].img7.tabSrc} />
                    <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[0].img7.moSrc} />
                    <img src={privateRoomData.inner[0].img7.pcSrc} alt="" />
                  </picture>
                </li>
              </div>
            </div>

          </div>

          <div className="privateroom__inner" ref={gallery}>

            {
              width >= 1921 ? (
                <div className="grid__gallery">

                  <div className="grid__lists">
                    <ul className="grid__list">
                      <li className="grid__item" ref={el => { gridWideItem.current[0] = el }}>
                        <picture>
                          <img src={privateRoomData.wide.img1_1} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridWideItem.current[1] = el }}>
                        <picture>
                          <img src={privateRoomData.wide.img1_2} alt="" />
                        </picture>
                      </li>
                    </ul>

                    <div className="grid__lists">
                      <ul className="grid__list">
                        <li className="grid__item" ref={el => { gridWideItem.current[2] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img2_1} alt="" />
                          </picture>
                        </li>
                        <li className="grid__item" ref={el => { gridWideItem.current[3] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img2_2} alt="" />
                          </picture>
                        </li>
                        <li className="grid__item" ref={el => { gridWideItem.current[4] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img2_3} alt="" />
                          </picture>
                        </li>
                      </ul>

                      <ul className="grid__list">
                        <li className="grid__item" ref={el => { gridWideItem.current[5] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img3_1} alt="" />
                          </picture>
                        </li>
                        <li className="grid__item" ref={el => { gridWideItem.current[6] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img3_2} alt="" />
                          </picture>
                        </li>
                        <li className="grid__item" ref={el => { gridWideItem.current[7] = el }}>
                          <picture>
                            <img src={privateRoomData.wide.img3_3} alt="" />
                          </picture>
                        </li>
                      </ul>
                    </div>

                    <ul className="grid__list">
                      <li className="grid__item" ref={el => { gridWideItem.current[8] = el }}>
                        <picture>
                          <img src={privateRoomData.wide.img4_1} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridWideItem.current[9] = el }}>
                        <picture>
                          <img src={privateRoomData.wide.img4_2} alt="" />
                        </picture>
                      </li>
                    </ul>
                  </div>

                  <div className="grid__lists">
                    <li className="grid__item" ref={el => { gridWideItem.current[10] = el }}>
                      <picture>
                        <img src={privateRoomData.wide.img5_1} alt="" />
                      </picture>
                    </li>
                    <li className="grid__item" ref={el => { gridWideItem.current[11] = el }}>
                      <picture>
                        <img src={privateRoomData.wide.img5_2} alt="" />
                      </picture>
                    </li>
                    <li className="grid__item" ref={el => { gridWideItem.current[12] = el }}>
                      <picture>
                        <img src={privateRoomData.wide.img5_3} alt="" />
                      </picture>
                    </li>
                    <li className="grid__item" ref={el => { gridWideItem.current[13] = el }}>
                      <picture>
                        <img src={privateRoomData.wide.img5_4} alt="" />
                      </picture>
                    </li>
                  </div>

                </div>
              ) : (
                <div className="grid__gallery">
                  <div className="grid__lists">

                    <ul className="grid__list">
                      <li className="grid__item" ref={el => { gridItem.current[0] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img1_1.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img1_1.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img1_1.moSrc} />
                          <img src={privateRoomData.inner[1].img1_1.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[1] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img1_2.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img1_2.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img1_2.moSrc} />
                          <img src={privateRoomData.inner[1].img1_2.pcSrc} alt="" />
                        </picture>
                      </li>
                    </ul>

                    <ul className="grid__list">
                      <li className="grid__item"
                        ref={el => { gridItem.current[2] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img2_1.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img2_1.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img2_1.moSrc} />
                          <img src={privateRoomData.inner[1].img2_1.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[3] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img2_2.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img2_2.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img2_2.moSrc} />
                          <img src={privateRoomData.inner[1].img2_2.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[4] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img2_3.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img2_3.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img2_3.moSrc} />
                          <img src={privateRoomData.inner[1].img2_3.pcSrc} alt="" />
                        </picture>
                      </li>
                    </ul>

                    <ul className="grid__list">
                      <li className="grid__item" ref={el => { gridItem.current[5] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img3_1.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img3_1.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img3_1.moSrc} />
                          <img src={privateRoomData.inner[1].img3_1.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[6] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img3_2.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img3_2.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img3_2.moSrc} />
                          <img src={privateRoomData.inner[1].img3_2.pcSrc} alt="" />
                        </picture>
                      </li>
                    </ul>
                  </div>

                  <div className="grid__lists">
                    <ul className="grid__list">
                      <li className="grid__item" ref={el => { gridItem.current[7] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img4_1.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img4_1.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img4_1.moSrc} />
                          <img src={privateRoomData.inner[1].img4_1.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[8] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img4_2.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img4_2.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img4_2.moSrc} />
                          <img src={privateRoomData.inner[1].img4_2.pcSrc} alt="" />
                        </picture>
                      </li>
                      <li className="grid__item" ref={el => { gridItem.current[9] = el }}>
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={privateRoomData.inner[1].img4_3.pcSrc} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={privateRoomData.inner[1].img4_3.tabSrc} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={privateRoomData.inner[1].img4_3.moSrc} />
                          <img src={privateRoomData.inner[1].img4_3.pcSrc} alt="" />
                        </picture>
                      </li>
                    </ul>
                  </div>
                </div>)
            }

          </div>


          <Outro />
          
          <Banner
            classType={bannerLobby.classType}
            title={bannerLobby.title}
            titleSrcPc={bannerLobby.titleSrcPc}
            titleSrcTab={bannerLobby.titleSrcTab}
            titleSrcMo={bannerLobby.titleSrcMo}
            unionSrc={bannerLobby.unionSrc}
            description1={bannerLobby.description1}
            description2={bannerLobby.description2}
            linkDesc={bannerLobby.linkDesc}
            link={bannerLobby.link}
          />
          <Banner
            classType={bannerLounge.classType}
            title={bannerLounge.title}
            titleSrcPc={bannerLounge.titleSrcPc}
            titleSrcTab={bannerLounge.titleSrcTab}
            titleSrcMo={bannerLounge.titleSrcMo}
            unionSrc={bannerLounge.unionSrc}
            description1={bannerLounge.description1}
            description2={bannerLounge.description2}
            linkDesc={bannerLounge.linkDesc}
            link={bannerLounge.link}
          />

          {/* (s) 페이지 전환 애니메이션 */}
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn" } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step1"
          />
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut", delay: 0.1 } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn", delay: 0.1 } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step2"
          />
          {/* (e) 페이지 전환 애니메이션 */}
        </section>
      </div>
    </div>
  )
}